import { Helper } from "../core/util/helper";
import { ResourcePlanningSchedulerEventViewModel, ResourcePlanningSchedulerSettingsViewModel } from "./resourcePlanningScheduler";
import { OnChangeField } from "./settings";
import React from "react";
export class Legend extends React.Component<LegendProps, any> {

    private circleRadius = 10;
    private barHeight = 20;


    private handleLegendItemClick = (knr: number) =>{
        if (this.props.onChange) {

            let knrs: Array<number> = this.props.settings.KNrs.slice(0);
            let index = knrs.indexOf(knr);
            if (index == -1)
                knrs.push(knr);
            else
                knrs.splice(index, 1);

            this.props.onChange({ model: "KNrs" }, knrs);
            this.setState({});
        }
    }


    private countEvents = (knr: number) => {
        const filter = (event: ResourcePlanningSchedulerEventViewModel) => {
            return event.KNr == knr && !event.IsAnnonymous
        }
        switch (this.props.settings.CodeCounterMode) {
            default:
            case 0:
                return 0;
            case 1:
                return this.props.events.filter(event => event.ResourceId.toLowerCase().indexOf("r|") > -1).filter(filter).length;
            case 2:
                return this.props.events.filter(event => event.ResourceId.toLowerCase().indexOf("g|") > -1).filter(filter).length;
            case 3:
                return this.props.events.filter(filter).length;
        }

    } 

    private renderBar = (entry: ResourcePlanningSchedulerLegendEntryViewModel) => {
        let width = 65;
        if (entry.Bezeichnung.length > 10)
            width = 85;

        //const key = Helper.getHashCode(`${entry.Knr}_${entry.Bezeichnung}`)
        const key = kendo.guid();
        
        return (
            <React.Fragment key={key}>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: `minmax(auto, ${width}px) repeat(${this.props.settings.CodeCounterMode == 0 ? "1" : "2"}, ${this.circleRadius}px)`,
                    gridTemplateRows: `repeat(5, ${(this.barHeight / 5)}px) ${(2 * this.circleRadius) - (0.8 * this.barHeight)}px`,
                    margin: "0 0 5px 5px"
                }}>
                    <div
                        style={{
                            gridColumn: "1/3",
                            gridRow: "1/6",
                            textAlign: "center",
                            minWidth: "50px",
                            display: "grid",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "2px",
                            color: entry.ForeColor,
                            backgroundColor: entry.BackColor,
                            cursor: /*this.props.slotModeActive ? null : */ "pointer",
                            borderRadius: "var(--border-radius)",
                            border: this.props.settings.KNrs.indexOf(entry.Knr) != -1 ? "2px solid black" : (entry.BackColor.toLowerCase() == "#ffffff" ? "1px solid black" : "2px solid rgba(0,0,0,0.25)")
                        }}
                        onClick={() => /*!this.props.slotModeActive && */ this.handleLegendItemClick(entry.Knr)}>
                            {entry.Bezeichnung}
                    </div>
                    <div
                        style={{
                            gridColumn: "2/4",
                            gridRow: "2/7",
                            backgroundColor: entry.BackColor,
                            border: `solid 2px rgba(0,0,0,0.25)`,
                            zIndex: 5,
                            borderRadius: `${this.circleRadius}px`,
                            color: entry.ForeColor,
                            display: this.props.settings.CodeCounterMode === 0 ? "none" : "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                        {this.countEvents(entry.Knr)}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        return (
            <div style={{ paddingRight: "2px", margin: "5px", fontSize: "11px", fontFamily: "Roboto", textAlign: "right", display: "flex", alignItems: "end", flexWrap: "wrap" }}>
                {this.props.settings.Legend.Entries.map(this.renderBar)}
            </div>
        );
    }
}



interface LegendProps {
    onChange?: (field: OnChangeField | Array<OnChangeField>, value: any | Array<any>, dataItem?: any) => void;
    settings: ResourcePlanningSchedulerSettingsViewModel;
    events: ResourcePlanningSchedulerEventViewModel[];
}

export interface ResourcePlanningSchedulerLegendEntryViewModel {
    Knr: number;
    Bezeichnung: string;
    BackColor: string;
    ForeColor: string;
}